export enum WorkflowType {
    Analytics = 'analytics',
    DataCheckin = 'data-checkin',
    Internal = 'internal',
}
